import { Select } from "antd";
import { t } from "i18next";
import AnswerTypePreview from "./AnswerTypePreview";
import { mergeAnswerTypeOptions } from "./answerTypes";
import "./styles.scss";

const { Option, OptGroup } = Select;

function AnswerTypeOption({ option }) {
    return (
        <div className="answer-type-option">
            <span className="answer-type-option-name">{option.name}</span>
            <AnswerTypePreview kind={option.preview} />
        </div>
    );
}

export default function AnswerTypeSelect({
    value,
    onChange,
    extraOptions = [],
    status,
    placeholder,
    onClick,
}) {
    const { presets, extras, options } = mergeAnswerTypeOptions(extraOptions);

    const renderOption = (option) => (
        <Option value={option.id} key={option.id}>
            <AnswerTypeOption option={option} />
        </Option>
    );

    return (
        <Select
            size="large"
            className="db-linear-select answer-type-select"
            popupClassName="criteria-list-select-dropdown answer-type-select-dropdown"
            dropdownStyle={{ zIndex: 999999 }}
            placeholder={placeholder || t("select.placeholder")}
            value={value}
            status={status}
            onClick={onClick}
            dropdownMatchSelectWidth
            onChange={(id) => {
                const selected = options.find(
                    (option) => String(option.id) === String(id)
                );
                if (selected) {
                    onChange(selected);
                }
            }}
        >
            {extras.length ? (
                <>
                    <OptGroup label={t("answer.type.group.standard")}>
                        {presets.map(renderOption)}
                    </OptGroup>
                    <OptGroup label={t("answer.type.group.saved")}>
                        {extras.map(renderOption)}
                    </OptGroup>
                </>
            ) : (
                presets.map(renderOption)
            )}
        </Select>
    );
}
